/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { EVENT_NAMES, PROP_NAMES, type Payload, track } from '@zcode/mixpanel'
import type { Dispatch, GetState } from '../../types'
import { getCommonProps } from '../helpers/getCommonProps'

export const mixpanelViewSection =
  (sectionName: string, extraPayload?: Payload) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    const payload = {
      [PROP_NAMES.SECTION]: sectionName,
      ...getCommonProps({ state, event: EVENT_NAMES.VIEW_SECTION }),
      ...extraPayload,
    }
    track({ event: EVENT_NAMES.VIEW_SECTION, payload })
  }
